<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">
    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="80%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr data-field="maps_enabled">
            <td align="right" width="500">Enabled</td>
            <td width="800"><b-form-select v-model="model.maps_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_link_builder_enabled">
            <td align="right" width="500">Map Link Builder</td>
            <td width="800"><b-form-select v-model="model.maps_link_builder_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_show_driver_phone">
            <td align="right" width="500">Show Driver Phone</td>
            <td width="800"><b-form-select v-model="model.maps_show_driver_phone" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_available_using_start_time">
            <td align="right" width="500">Available Using Start Time</td>
            <td width="800"><b-form-select v-model="model.maps_available_using_start_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_available_using_position_time">
            <td align="right" width="500">Available Using Position Time</td>
            <td width="800"><b-form-select v-model="model.maps_available_using_position_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_available_minutes_before_booking">
            <td align="right" width="500">Available Minutes Before Booking</td>
            <td width="800">
              <b-form-input v-model="model.maps_available_minutes_before_booking" type="text" :state="numericState('maps_available_minutes_before_booking')" @input="validateNumeric('maps_available_minutes_before_booking', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('maps_available_minutes_before_booking')">{{ numericFeedback('maps_available_minutes_before_booking') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="maps_available_minutes_after_booking">
            <td align="right" width="500">Available Minutes After Booking</td>
            <td width="800">
              <b-form-input v-model="model.maps_available_minutes_after_booking" type="text" :state="numericState('maps_available_minutes_after_booking')" @input="validateNumeric('maps_available_minutes_after_booking', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('maps_available_minutes_after_booking')">{{ numericFeedback('maps_available_minutes_after_booking') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="map_fleet_filter_by_vehicle_orgs">
            <td align="right" width="500">Map By Org - Filter By Vehicle (Org Names)</td>
            <td width="800"><JsonTagListEditor v-model="model.map_fleet_filter_by_vehicle_orgs" fieldKey="map_fleet_filter_by_vehicle_orgs" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" valueLabel="Org Name" placeholder="e.g. Ambassatours Cruise Corp."/>
                <b-form-invalid-feedback :state="jsonState('map_fleet_filter_by_vehicle_orgs')">{{ jsonFeedback('map_fleet_filter_by_vehicle_orgs') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="isEffectiveAdmin">
            <td align="right"><span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">{{ toggle.isAdvVisible ? "▾" : "▸" }} Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr data-field="maps_show_pickup_dropoff_eta">
              <td align="right" width="500">Show ETAs (extra usage fees involved)</td>
              <td width="800"><b-form-select v-model="model.maps_show_pickup_dropoff_eta" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
        </table>


      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  <div class="tc-sticky-save">
    <transition name="tc-save-slide">
    <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
      <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
      <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
      &nbsp;&nbsp;
      <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
    </div>
    </transition>
  </div>
</div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import JsonTagListEditor from './JsonTagListEditor.vue'

export default {
  name: 'tenant_config',
  mixins: [numericValidationMixin, dirtyTrackingMixin, jsonValidationMixin],
  components: {
    JsonTagListEditor,
  },

  data() {
    return {
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      jsonFieldToggleMap: {},
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        if (dirtyKeys.size === 0) {
          this.$emit('showAlert', 'No changes to save', 'info', 3000)
          return
        }
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        await update_tenant_config_settings(this.user.tenant, payload)
        this._resetDirtyTracking()
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

